(function() {
    var datepickerOptions = {
        changeMonth: true,
        changeYear: true,
        altFormat: "yy-mm-dd",
        dateFormat:'dd/mm/yy',
        minDate: "-90Y",
        maxDate: "+0Y",
        yearRange: "-90:+0"
    };
    
    $('.ui-date-picker').each(function () {
        var $field = $(this)
        var fieldOptions = $.extend(datepickerOptions, $field.data())

        $field.datepicker($.extend(fieldOptions, {
            altField: $field.next()
        }));
    });
    
    $('.future-date-picker').each(function () {
        $(this).datepicker($.extend(datepickerOptions, {
            minDate: "+0Y",
            maxDate: "+20Y",
            yearRange: "+0:+20",
            altField: $(this).next()
        }));
    });
    
    $('.past-and-future-date-picker').each(function () {
        var field = $(this)
        var altField = field.next()

        var minDate = "-20Y"
        var yearRange = "-20:+20"

        var dateLargeYearRange = $(this).data('large-year-range')
        if(dateLargeYearRange != 'undefined' && dateLargeYearRange == true){
            minDate = "-80Y"
            yearRange = "-80:+20"
        }

        field.datepicker($.extend(datepickerOptions, {
            minDate: minDate,
            maxDate: "+20Y",
            yearRange: yearRange,
            altField: altField
        }));
    
        field.on('change', function() {
            altField.trigger('change')
        });
    });
    
    $('.date-time-picker').datetimepicker({
        timepicker:false,
        format:'Y-m-d'
    });
    
    $('.time-picker').datetimepicker({
        datepicker:false,
        format:'H:i',
        step:5,
    });
})()
